import Store from 'store/store'
import { Component } from 'utils/jsx'
import { load } from 'store/file'

import LocalStorage from 'store/local-storage'
import APIServer from 'controllers/api-server'

import Button from 'components/dom/Button'
import FileDropper from 'components/dom/FileDropper'

export default class Landing extends Component {
  beforeRender () {
    this.handleVisibility = this.handleVisibility.bind(this)
    this.handleNew = this.handleNew.bind(this)
    this.handleRestore = this.handleRestore.bind(this)
    this.handleLoad = this.handleLoad.bind(this)
  }

  template (props) {
    return (
      <section class='landing'>
        <FileDropper event-change={this.handleLoad} />

        <div class='landing__title'>{window.ENV.name}</div>
        <div class='landing__versions'>
          <div data-version='app'>{window.ENV.version}</div>
          <div data-version='api' store-text={Store.APIServer.version} />
        </div>

        <div class='landing__content'>
          <Button
            ref={this.ref('buttonNew')}
            icon='file-o'
            event-click={this.handleNew}
          >Nouveau projet</Button>

          {
            LocalStorage.exists &&
              <Button
                ref={this.ref('buttonRestore')}
                icon='redo-alt'
                event-click={this.handleRestore}
              >Reprendre</Button>
          }

          <Button
            ref={this.ref('buttonLoad')}
            icon='folder-open-o'
            event-click={this.handleLoad}
          >Charger</Button>
        </div>

      </section>
    )
  }

  afterRender () {
    Store.app.showLanding.subscribe(this.handleVisibility)
    this.handleVisibility()
  }

  handleVisibility () {
    const visible = Store.app.showLanding.get()
    if (visible) this.base.classList.remove('is-hidden')
    else this.base.classList.add('is-hidden')
  }

  handleNew () {
    LocalStorage.clear()
    LocalStorage.store()
    LocalStorage.register()
    APIServer.log('new project')
    this.exit(this.refs.buttonNew)
  }

  handleRestore () {
    LocalStorage.restore()
    LocalStorage.register()

    APIServer.log('restore project', { seed: Store.landscape.seed.get() })
    this.exit(this.refs.buttonRestore)
  }

  async handleLoad (files = []) {
    LocalStorage.register()
    await load((files && files.length) ? files[0] : null)
    APIServer.log('load project', { seed: Store.landscape.seed.get() })
    this.exit(this.refs.buttonLoad)
  }

  exit (buttonPressed) {
    for (const el of this.base.querySelectorAll('.button.is-pressed')) {
      el.classList.remove('is-pressed')
    }

    buttonPressed.base.classList.add('is-pressed')
    Store.app.showLanding.set(false)
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Landing.js